import { MessageLogsModule } from '@administration/message-log/message-logs.module';
import { Routes } from '@angular/router';
import { UnauthorizedComponent } from '@common/components/unauthorized.component';
import _ from 'lodash';
import { LoginComponent } from './common/components/login/login.component';
import { LogoutComponent } from './common/components/logout.component';
import { AuthGuard } from './common/guards/auth.guard';
import { UserAccountModule } from './user-account/user-account.module';
import { UserSettingsModule } from './user-settings/user-settings.module';

export const ROUTES: Routes = [
    { path: 'login', component: LoginComponent },
    { path: '401', component: UnauthorizedComponent },
    { path: 'logout', component: LogoutComponent },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            { path: '', redirectTo: '/port-koper-map', pathMatch: 'full' },
            {
                path: 'dashboard',
                loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
                data: { title: 'Dashboard' }
            },
            {
                path: 'port-koper-map',
                loadChildren: () =>
                    import('./port-koper-map/port-koper-map/port-koper-map.module').then((m) => m.PortKoperMapModule),
                data: { title: _('Port of Koper Map') }
            },
            {
                path: 'administration',
                loadChildren: () =>
                    import('./administration/administration.module').then((m) => m.AdministrationModule),
                data: { title: _('Administration') }
            },
            {
                path: 'vessel-announcement',
                loadChildren: () =>
                    import('./vessel-announcement/vessel-operation-control.module').then(
                        (m) => m.VesselOperationControlModule
                    ),
                data: { title: _('Vessel Operation Control') }
            },
            {
                path: 'vessel-arrival',
                loadChildren: () => import('./vessel-arival/vessel-arival.module').then((m) => m.VesselArivalModule),
                data: { title: _('Vessel Arrival') }
            },
            {
                path: 'vessel-visit',
                loadChildren: () => import('./vessel-visit/vessel-visit.module').then((m) => m.VesselVisitModule),
                data: { title: _('Vessel Visits') }
            },
            {
                path: 'vessel-announcement',
                loadChildren: () =>
                    import('./vessel-announcement/vessel-operation-control.module').then(
                        (m) => m.VesselOperationControlModule
                    ),
                data: { title: _('Vessel Operation Control') }
            },
            {
                path: 'vessel-visit',
                loadChildren: () => import('./vessel-visit/vessel-visit.module').then((m) => m.VesselVisitModule),
                data: { title: _('Vessel Visits') }
            },
            {
                path: 'berth-plan',
                loadChildren: () => import('./berth-plan/berth-plan.module').then((m) => m.BerthPlanModule),
                data: { title: _('Berthing Plans') }
            },
            {
                path: 'protests',
                loadChildren: () => import('./protests/protests/protests.module').then((m) => m.ProtestsModule),
                data: { title: _('Protests') }
            },
            {
                path: 'event-evidence',
                loadChildren: () =>
                    import('./event-evidence/event-evidence/event-evidence.module').then((m) => m.EventEvidenceModule),
                data: { title: _('Event evidence') }
            },
            {
                path: 'near-event-evidence',
                loadChildren: () =>
                    import('./near-events-evidence/near-events-evidence.module').then(
                        (m) => m.NearEventsEvidenceModule
                    ),
                data: { title: _('Near event evidence') }
            },
            {
                path: 'bunkers',
                loadChildren: () => import('./bunkers-list/bunkers-list.module').then((m) => m.BunkersListModule),
                data: { title: _('Bunkers') }
            },
            {
                path: 'vessels',
                loadChildren: () => import('./vessels/vessels.module').then((m) => m.VesselsModule),
                data: { title: _('Vessels') }
            },
            {
                path: 'user-account',
                loadChildren: () => UserAccountModule,
                data: { title: _('Account') }
            },
            {
                path: 'user-settings',
                loadChildren: () => UserSettingsModule,
                data: { title: _('User Settings') }
            },
            {
                path: 'message-logs',
                loadChildren: () => MessageLogsModule,
                data: { title: _('Message logs') }
            },
            {
                path: 'pilotage-plans',
                loadChildren: () => import('./pilotage-plans/pilotage-plans.module').then((m) => m.PilotagePlansModule),
                data: { title: _('Pilotage plans') }
            },
            {
                path: 'monthly-plans',
                loadChildren: () => import('./montly-plans/monthly-plans.module').then((m) => m.MonthlyPlansModule),
                data: { title: _('Monthly plans') }
            },
            {
                path: 'reports',
                loadChildren: () => import('./reports/reports.module').then((m) => m.ReportsModule),
                data: { title: _('Reports') }
            },
            {
                path: 'tug-boats',
                loadChildren: () => import('./tug-boats/tug-boats.module').then((m) => m.TugBoatsModule),
                data: { title: _('Tug boats') }
            },
            { path: '**', redirectTo: '/' }
        ]
    }
];
